import * as React from 'react';
import * as autoBind from 'react-autobind';
import Strings from '../../globals/Strings';
import ReviewerGroupModel from '../../types/ReviewerGroupModel';
import {TscButtonType, ControlButton} from '@techsmith/tsc-cloud-style-guide';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import Themeable from '../../types/Themeable';
import SaveGroupModal from '../SaveGroupModal/SaveGroupModal';

export default class SaveGroupButton extends React.Component<SaveGroupButtonProps, SaveGroupButtonState> {
   readonly state: SaveGroupButtonState = {showAlert: false};

   constructor(props: SaveGroupButtonProps) {
      super(props);
      autoBind(this);
   }

   isButtonVisible(): boolean {
      const {reviewers, reviewerGroups} = this.props;
      if (reviewers.length === 0) {
         return false;
      }

      if (reviewerGroups.length === 0) {
         return true;
      }

      const reviewerEmailsString = reviewers.map(r => r.Email).sort().join();
      for (const reviewerGroup of reviewerGroups) {
         const reviewerGroupMembersString = reviewerGroup.GroupMembers.map(m => m.Email).sort().join();

         if (reviewerEmailsString === reviewerGroupMembersString) {
            return false;
         }
      }

      return true;
   }

   onShowSaveGroupModal(): void {
      this.setState({showAlert: true});
   }

   onCloseSaveGroupModal(): void {
      this.setState({showAlert: false});
   }

   render(): React.ReactElement<any> {
      const {showAlert} = this.state;
      const {reviewers, reviewerGroups, themeName} = this.props;
      const {saveGroup} = Strings.labels;

      return (
         <React.Fragment>
            {this.isButtonVisible() && <div className="save-group-container"><ControlButton title={saveGroup} label={saveGroup} themeName={this.props.themeName} buttonType={TscButtonType.tertiary} onClick={this.onShowSaveGroupModal} testId="save-group-button"/></div>}
            {showAlert && <SaveGroupModal reviewers={reviewers} reviewerGroups={reviewerGroups} onClose={this.onCloseSaveGroupModal} themeName={themeName} />}
         </React.Fragment>
      );
   }
}

export interface SaveGroupButtonProps extends Themeable {
   reviewers: SimpleReviewerModel[];
   reviewerGroups: ReviewerGroupModel[];
}

export interface SaveGroupButtonState {
   showAlert: boolean;
}
